import React from "react";

interface PercentageChangeProps {
    value: number | null;
    inverse?: boolean;
    rounded?: number;
    format?: string;
}

type FormatType = "percentage" | "pp";

const PercentageChange: React.FC<
    PercentageChangeProps & { format?: FormatType }
> = ({
    value,
    inverse = false,
    rounded = 0,
    format = "percentage",
}) => {
        if (value === null || value === undefined) return null;

        const suffix = format === "pp" ? "pp" : "%";

        const isZeroAfterRound =
            Number(value.toFixed(rounded)) === 0;

        const isDash = value === 0 || isZeroAfterRound;

        const color =
            isDash
                ? "rgba(145, 158, 171, 1)"
                : value > 0
                    ? (inverse
                        ? "rgba(220, 24, 24, 1)"
                        : "rgba(0, 162, 91, 1)")
                    : value < 0
                        ? (inverse
                            ? "rgba(0, 162, 91, 1)"
                            : "rgba(220, 24, 24, 1)")
                        : "rgba(145, 158, 171, 1)";

        const style: React.CSSProperties = {
            color,
            marginLeft: "8px",
            textAlign: "right",
            fontVariantNumeric: "lining-nums tabular-nums",
            fontFamily: 'var(--font-family-Font-1, "Public Sans")',
            fontSize: "14px",
            lineHeight: "22px",
        };

        if (value > 1000) {
            return <span style={style}>{`>999${suffix}`}</span>;
        }

        if (value < -1000) {
            return <span style={style}>{`<-999${suffix}`}</span>;
        }

        const roundedValue = Number(value.toFixed(rounded));

        if (roundedValue === 0) {
            return <span style={style}>-</span>;
        }

        const sign = roundedValue > 0 ? "+" : "";

        return (
            <span style={style}>
                {sign}
                {roundedValue}
                {suffix}
            </span>
        );
    };

export default PercentageChange;